/* 
// ///////////////
// Fine name: adsConfigurations.js
// Description: // This file contains all the data and configs related to Ads 
// ///////////////
*/

import googleIcon from "assets/images/Google ads icone.png";
import metaIcon from "assets/images/Meta icone.png";
import shopifyIcon from "assets/images/shopify-logo.png";
import tiktokIcon from "assets/images/tictok_icon.png";
import snapchatIcon from "assets/images/snapchat_icon.png";
import linkedinIcon from "assets/images/linkedin_icon.png";
import redditIcon from "assets/images/reddit_icon.svg";
import hotmartIcon from "assets/images/hotmart_icon.svg";

const BASE_URL = process.env.REACT_APP_API_URL;

export const platformDetailsData = [
  {
    name: "Google Ads",
    slug: "google",
    icon: googleIcon,
    description: `Google Ads is an online advertising platform developed by Google, where advertisers bid to display brief a
                  dvertisements, service offerings, product listings, or videos to web users.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Meta Ads",
    slug: "meta",
    icon: metaIcon,
    description: `Meta Ads Manager leverages its social media platforms to facilitate targeted advertising, brand promotion, 
                  and audience engagement through advanced data analytics, creativity and audience segmentation.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Shopify Ads",
    slug: "shopify",
    icon: shopifyIcon,
    description: `Shopify is a Canadian e-commerce company that provides a platform for businesses to set up and manage online stores.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Tiktok Ads",
    slug: "tiktok",
    icon: tiktokIcon,
    description: `TikTok Ads provides a powerful platform for brands to reach and engage a global audience through short-form videos. 
                It offers diverse ad formats, precise audience targeting, and performance tracking to maximize campaign effectiveness.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Snapchat Ads",
    slug: "snapchat",
    icon: snapchatIcon,
    description: `Snapchat Ads provide a way for businesses to reach a younger audience through engaging video ads.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "LinkedIn Ads",
    slug: "linkedin",
    icon: linkedinIcon,
    description: `LinkedIn Ads provide a platform for businesses to target professionals through engaging ad formats.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Reddit Ads",
    slug: "reddit",
    icon: redditIcon,
    description: `Reddit Ads permet de toucher des communautés très engagées par centres d'intérêt (subreddits),
                  avec un ciblage par sujet et un coût d'entrée bas comparé aux grandes régies généralistes.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Hotmart",
    slug: "hotmart",
    icon: hotmartIcon,
    description: `Hotmart est une plateforme de produits numériques et d'affiliation (formations, ebooks).
                  Connectez-la pour synchroniser votre catalogue et suivre vos ventes depuis OneBotAds.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
  {
    name: "Shopify OAuth Ads",
    slug: "shopify-oauth",
    icon: shopifyIcon, // Reusing Shopify icon, or use a new one if desired
    description: `Shopify OAuth Ads integrates with your Shopify store via OAuth to manage advertising campaigns directly from your store’s data.`,
    isConnected: false,
    tagline: "PREMIUM",
  },
];

export const allAdConfigurations = {
  googleAdsConfiguration: {
    name: "Google Ads",
    authUrl: `${BASE_URL}/api/ads-auth/google`,
    slug: "google",
    permissions: [
      {
        detail: "Manage Search campaigns",
        isAllowed: true,
      },
      {
        detail: "Manage Performance Max campaigns",
        isAllowed: true,
      },
      {
        detail: "Perform keyword analysis",
        isAllowed: true,
      },
    ],
  },

  metaAdsConfiguration: {
    name: "Meta Ads",
    authUrl: `${BASE_URL}/api/ads-auth/meta`,
    slug: "meta",
    permissions: [
      {
        detail: "Create campaigns",
        isAllowed: true,
      },
      {
        detail: "Manage ads",
        isAllowed: true,
      },
      {
        detail: "Fetch metrics and ads reports",
        isAllowed: true,
      },
    ],
  },

  shopifyAdsConfiguration: {
    name: "Shopify Ads",
    authUrl: null,
    slug: "shopify",
    permissions: [
      {
        detail: "Read and update products",
        isAllowed: true,
      },
      {
        detail: "Read orders",
        isAllowed: true,
      },
      {
        detail: "Remove all your information",
        isAllowed: false,
      },
    ],
  },
  tiktokAdsConfiguration: {
    name: "Tiktok Ads",
    authUrl: `${BASE_URL}/api/ads-auth/tiktok`,
    slug: "tiktok",
    permissions: [
      {
        detail: "Create and manage ad campaigns",
        isAllowed: true,
      },
      {
        detail: "Access audience insights and analytics",
        isAllowed: true,
      },
      {
        detail: "Optimize ads using AI-driven recommendations",
        isAllowed: true,
      },
    ],
  },

  snapchatAdsConfiguration: {
    name: "Snapchat Ads",
    authUrl: `${BASE_URL}/api/ads-auth/snapchat`,
    slug: "snapchat",
    permissions: [
      {
        detail: "Manage Snapchat campaigns",
        isAllowed: true,
      },
      {
        detail: "Analyze audience insights",
        isAllowed: true,
      },
    ],
  },
  linkedinAdsConfiguration: {
    name: "LinkedIn Ads",
    authUrl: `${BASE_URL}/api/ads-auth/linkedin`,
    slug: "linkedin",
    permissions: [
      {
        detail: "Manage LinkedIn Ad Campaigns",
        isAllowed: true,
      },
      {
        detail: "Access audience analytics",
        isAllowed: true,
      },
    ],
  },
  redditAdsConfiguration: {
    name: "Reddit Ads",
    authUrl: `${BASE_URL}/api/ads-auth/reddit`,
    slug: "reddit",
    permissions: [
      { detail: "Manage Reddit ad campaigns", isAllowed: true },
      { detail: "Read Reddit ad accounts and performance", isAllowed: true },
    ],
  },
  hotmartConfiguration: {
    name: "Hotmart",
    // Pas de tunnel OAuth : Hotmart fonctionne en client_credentials, les
    // identifiants sont saisis dans le modal de configuration.
    authUrl: null,
    slug: "hotmart",
    permissions: [
      { detail: "Read your product catalog", isAllowed: true },
      { detail: "Read sales history and subscriptions", isAllowed: true },
      { detail: "Create or modify products", isAllowed: false },
    ],
  },
  shopifyOAuthAdsConfiguration: {
    // New configuration
    name: "Shopify OAuth Ads",
    authUrl: `${BASE_URL}/api/ads-auth/shopify-oauth-ads`, // Base URL, shop name will be appended
    slug: "shopify-oauth",
    permissions: [
      { detail: "Manage Shopify ad campaigns", isAllowed: true },
      { detail: "Access store data for ad targeting", isAllowed: true },
      { detail: "Fetch ad performance metrics", isAllowed: true },
    ],
  },
};

export const isOAuthFlow = (platformName) => {
  return [
    allAdConfigurations.googleAdsConfiguration.slug,
    allAdConfigurations.metaAdsConfiguration.slug,
    allAdConfigurations.tiktokAdsConfiguration.slug,
    allAdConfigurations.snapchatAdsConfiguration.slug,
    allAdConfigurations.linkedinAdsConfiguration.slug,
    allAdConfigurations.redditAdsConfiguration.slug,
    allAdConfigurations.shopifyOAuthAdsConfiguration.slug,
  ].includes(platformName);
};
